import type { ReactNode } from "react";

import { Disclosure, DisclosurePanel } from "react-aria-components";

import styles from "./collapsible.module.css";

export type CollapsibleHeaderProps = {
	isExpanded: boolean;
};

type CollapsibleProps = {
	children: ReactNode;
	/** Omit to drive the panel from a trigger rendered outside the collapsible. */
	header?: (props: CollapsibleHeaderProps) => ReactNode;
	/** Omit to let the panel manage its own expanded state. */
	isExpanded?: boolean;
	onExpandedChange?: (isExpanded: boolean) => void;
};

export function Collapsible({ children, header, isExpanded, onExpandedChange }: CollapsibleProps) {
	return (
		<Disclosure isExpanded={isExpanded} onExpandedChange={onExpandedChange}>
			{({ isExpanded }) => {
				return (
					<>
						{header?.({ isExpanded })}
						<DisclosurePanel className={styles.panel} role="region">
							{children}
						</DisclosurePanel>
					</>
				);
			}}
		</Disclosure>
	);
}
